// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@popperjs/core"
import "bootstrap"
import { Tooltip } from "bootstrap"
import "./controllers"
import "./turbo_stream_actions"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import dragscroll from "./dragscroll"

// Google Tag Manager - Turbo Drive対応
let isInitialLoad = true;
document.addEventListener('turbo:load', () => {
  // Turbo Driveのページ遷移時（2回目以降）にページビューを送信
  if (!isInitialLoad && typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'turbo:load',
      page: window.location.pathname
    });
  }
  isInitialLoad = false;

  dragscroll.reset();
  initTooltips();

  const navToggles = document.querySelectorAll(".nav-toggle");
  const dbWrapper = document.getElementById("db-wrapper");
  if (navToggles && dbWrapper) {
    navToggles.forEach(navToggle => {
      navToggle.addEventListener("click", function (e) {
        e.preventDefault();
        dbWrapper.classList.toggle("toggled");
      });
    })
  }
})
document.addEventListener('turbo:frame-render', () => {
  dragscroll.reset();
  initTooltips();
})

document.addEventListener('turbo:before-stream-render', () => {
  disposeTooltips();
})

function disposeTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    const tooltip = Tooltip.getInstance(el)
    if (tooltip) tooltip.dispose()
  })
}

function initTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    if (!Tooltip.getInstance(el)) {
      new Tooltip(el, { delay: { show: 0, hide: 0 } })
    }
  })
}